<template>
  <NuxtLink class="p-1.5 block rounded-bl shadow-lg cursor-pointer" :class="backgroundClass" :to="routeToCampaign">
    <ContentfulImage class="mx-1" :width="18" :height="18" :entry="icon" />
    <div class="text-xs font-semibold text-white">
      {{ title }}
    </div>
  </NuxtLink>
</template>

<script setup lang="ts">
import { setCmsTemplateClassesCampaignBadges } from '@/config/cms';

type Props = {
  title?: string | null;
  icon?: any;
  isAssortment?: boolean;
  slug?: string;
  template?: string | null;
};

const props = withDefaults(defineProps<Props>(), {
  title: null,
  icon: null,
  isAssortment: false,
  slug: '',
  template: null,
});

const { path } = useRoute();

const backgroundClass = computed(() => {
  if (!props?.template) return null;
  return setCmsTemplateClassesCampaignBadges(props.template);
});

const routeToCampaign = computed(() => {
  /**
   * check to see if your current slug is matching the slug that is sent through the badge
   * This is to stop the user from rerouting to the same page they are already on but allowing
   * the user to route to a different campaign page
   */
  if (path !== props.slug) {
    return !props.isAssortment ? linkToCampaignPage(props.slug) : linkToAssortmentPage(props.slug);
  } else return '';
});
</script>

<script lang="ts">
export default defineComponent({
  name: 'CampaignBadge',
});
</script>
